import { IModal } from '@epam/uui-core';
import { useState } from 'react';
import {
  Button,
  ModalBlocker,
  ModalHeader,
  ModalWindow,
  Panel,
  TextInput,
} from '@epam/promo';
import { FlexRow } from '@epam/uui';

import css from './BroadcastTagsPage.module.scss';
import { BroadcastTag } from '../../../models/broadcastTag.model';

interface EditTagModalProps {
  tag: BroadcastTag;
  modalProps: IModal<string>;
  onUpdate: (data: { id: string; name: string }) => void;
}

export const EditTagModal = ({
  tag,
  modalProps,
  onUpdate,
}: EditTagModalProps) => {
  const [value, setValue] = useState(tag.name);

  const handleUpdate = () => {
    onUpdate({ id: tag.id, name: value });
    modalProps.abort();
  };

  return (
    <ModalBlocker
      key={modalProps.key}
      abort={modalProps.abort}
      isActive={modalProps.isActive}
      success={modalProps.abort}
      zIndex={modalProps.zIndex}>
      <ModalWindow width="420">
        <Panel background="white">
          <ModalHeader title={tag.name} onClose={modalProps.abort} />
          <Panel cx={css.modalBody}>
            <TextInput
              placeholder="Enter new tag name"
              value={value}
              onValueChange={(val) => setValue(val ?? '')}
            />
            <FlexRow columnGap="12" cx={css.modalActions}>
              <Button caption="Update" color="blue" onClick={handleUpdate} />
              <Button
                caption="Cancel"
                color="gray"
                fill="solid"
                onClick={modalProps.abort}
              />
            </FlexRow>
          </Panel>
        </Panel>
      </ModalWindow>
    </ModalBlocker>
  );
};
